import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import CashBeeModal from './components/CashBeeModal';

app.initializers.add('thecashbuzz-cashbee-ai', () => {
  // Add "Summarise with CashBee" to the discussion controls dropdown.
  // The button only appears when a user is logged in and the admin has
  // configured an API key. Per-group permission is enforced server-side.
  extend(DiscussionControls, 'userControls', (items, discussion) => {
    if (!app.session.user || !app.forum.attribute('cashbeeConfigured')) {
      return;
    }

    items.add(
      'cashbee',
      Button.component(
        {
          icon: 'fas fa-robot',
          onclick: () => app.modal.show(CashBeeModal, { discussion }),
        },
        app.translator.trans('thecashbuzz-cashbee-ai.forum.controls.summarise')
      )
    );
  });
});
